export default __webpack_public_path__ + "static/cta-video-e50caab5a200d5b8f1f26d474bf531cf.mp4";